/*
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Date: 2022-03-14 11:14:22
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @LastEditTime: 2024-01-18 15:33:53
 * @FilePath: \rental-oauth-management\src\util\author.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export default { 
    systemMenuPermissionsRootList: 'systemMenuPermissionsRootList',  // 所有权限集合

    dataAnalysis_executeList_passAndexecute: "dataAnalysis_executeList_passAndexecute", // 数据分析-SQL执行情况-通过并执行
    dataAnalysis_executeList_refuseToExecute: 'dataAnalysis_executeList_refuseToExecute', // 数据分析-SQL执行情况-拒绝执行

    systemPrivilege_userManage_add: 'systemPrivilege_userManage_add', // 系统权限-用户管理-添加用户
    systemPrivilege_userManage_SyncData: 'systemPrivilege_userManage_SyncData', // 系统权限-用户管理-同步钉钉数据
    systemPrivilege_userManage_edit: 'systemPrivilege_userManage_edit', // 系统权限-用户管理-编辑
    systemPrivilege_userManage_changePassword: 'systemPrivilege_userManage_changePassword', // 系统权限-用户管理-修改密码
    systemPrivilege_userManage_changeRole: 'systemPrivilege_userManage_changeRole', // 系统权限-用户管理-修改角色
    systemPrivilege_userManage_dataAuthorization: 'systemPrivilege_userManage_dataAuthorization', // 系统权限-用户管理-数据授权
    systemPrivilege_userManage_businessOwnership: 'systemPrivilege_userManage_businessOwnership', // 系统权限-用户管理-业务归属
}